import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  assetBalance: { image: '', name: '', key: '', fullName: '', idUser: '', symbol: '' },
  likeToken: [''],
}

const MySpaceSlice = createSlice({
  name: 'my-space',
  initialState,
  reducers: {
    setAssetBalance: (state, action) => {
      state.assetBalance = action.payload
    },
    setLikeToken: (state, action) => {
      state.likeToken = action.payload
    },
  },
  extraReducers: () => {},
})
export const MySpaceActions = MySpaceSlice.actions
const mySpaceReducer = MySpaceSlice.reducer
export default mySpaceReducer
